export const macDownloadLink = `https://cdn.startpage-app.com/startpage/releases/0.9.2/Darwin_x86_64-aarch64/Startpage%200.9.2.dmg`
export const windowsDownloadLink = `https://cdn.startpage-app.com/startpage/releases/0.9.2/WINNT_x86_64/Startpage%20Setup%200.9.2.exe`
